// 	export default  [
// xs	<768px 响应式栅格数或者栅格属性对象	number/object (例如： {span: 4, offset: 4})	—	—
// sm	≥768px 响应式栅格数或者栅格属性对象	number/object (例如： {span: 4, offset: 4})	—	—
// md	≥992px 响应式栅格数或者栅格属性对象	number/object (例如： {span: 4, offset: 4})	—	—
// lg	≥1200px 响应式栅格数或者栅格属性对象	number/object (例如： {span: 4, offset: 4})	—	—
// xl	≥1920px 响应式栅格数或者栅格属性对象	number/object (例如： {span: 4, offset: 4})
// // ]

export default [
	{ label:'药品名称：',xs:12,sm:12,md:8,lg:8,xl:8,type:'selectName',modelValue:'drugId',prop:'drugId',op:'nameOption'},
	{ label:'规格描述：',xs:12,sm:12,md:8,lg:8,xl:8,type:'input',modelValue:'drugspec',prop:'drugspec',op:'selectOption'},
	// { label:'库存序号：',xs:12,sm:12,md:5,lg:4,xl:4,type:'input',modelValue:'invyId',prop:'invyId',disabled:true},
	{ label:'当前库存数量：',  xs:12,sm:12,md:8,lg:8,xl:8,type:'input',modelValue:'purcCnt',prop:'purcCnt',disabled:true},
	
	{ label:'生产批号：',  xs:12,sm:12,md:6,lg:6,xl:6,type:'input',modelValue:'manuLotnum',prop:'manuLotnum',disabled:true},
	{ label:'生产厂家：',xs:12,sm:12,md:6,lg:6,xl:6,type:'input',modelValue:'prodentpName',prop:'prodentpName',disabled:true},
	{ label:'成本单价：',     xs:12,sm:12,md:4,lg:4,xl:4,type:'input',modelValue:'purcPric',prop:'purcPric',disabled:true},
	{ label:'成本金额：',xs:12,sm:12,md:4,lg:4,xl:4,type:'input',modelValue:'purcAmt',prop:'purcAmt',disabled:true },
	{ label:'销售单价：',     xs:12,sm:12,md:4,lg:4,xl:4,type:'input',modelValue:'salePric',prop:'salePric',disabled:true},
	
	{ label:'销售金额：',xs:12,sm:12,md:4,lg:4,xl:4,type:'input',modelValue:'saleAmt',prop:'saleAmt',disabled:true},
	
	{ label:'生产日期：',  xs:12,sm:12,md:6,lg:6,xl:6,type:'input',modelValue:'manuDate',prop:'manuDate',disabled:true},
	{ label:'有效日期：',  xs:12,sm:12,md:6,lg:6,xl:6,type:'input',modelValue:'expyDate',prop:'expyDate',disabled:true},
	// { label:'库存类型：',  xs:12,sm:12,md:8,lg:6,xl:6,type:'select',modelValue:'purcType',prop:'purcType',op:'kcOptions'},
	{ label:'调拨数量：',  xs:12,sm:12,md:8,lg:8,xl:8,type:'inputNum',modelValue:'apllyAmt',prop:'apllyAmt'},

	{ label:'加入' ,xs:24,sm:24,md:24,lg:12,xl:12,type:'btn',disabled:true,modelValue:'educationalBackground'},
]

